import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import LoanApplicationDashboard from '@app/views/LoanApplication/Dashboard';
import { memo } from 'react';

export default memo(
  withIfUser(LoanApplicationDashboard)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
